/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Reseller API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

/**
 * Health check used by the Kubernetes readiness and liveness probes. No auth.
 */
export const healthResponse = zod.object({
  status: zod.enum(['ok']),
});

/**
 * Payment terminal view
 */
export const terminalPaymentTransactionParams = zod.object({
  id: zod.string(),
});

/**
 * List available personas for identity
 */
export const authAvailablePersonasListResponseItem = zod.object({
  id: zod.string().uuid(),
  organization_id: zod.string(),
  reseller_id: zod.string().uuid(),
  email: zod.string().email(),
  permissions: zod.array(zod.string()),
  created_at: zod.string().datetime({}),
  deleted_at: zod.string().datetime({}).optional(),
});
export const authAvailablePersonasListResponse = zod.array(
  authAvailablePersonasListResponseItem,
);

/**
 * Get Access token for Reseller
 */
export const authAccessTokenGetParams = zod.object({
  resellerId: zod.string(),
});

export const authAccessTokenGetResponse = zod.object({
  access_token: zod.string(),
});

/**
 * Start login flow for managing self-service offerings
 */
export const selfserviceLoginParams = zod.object({
  slug: zod.string(),
});

/**
 * List available resellers
 */
export const resellersListResponseItem = zod
  .object({
    name: zod.string(),
    contact_name: zod.string(),
    contact_email: zod.string(),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
    }),
  );
export const resellersListResponse = zod.array(resellersListResponseItem);

/**
 * Create a new reseller
 */
export const resellerCreateBody = zod
  .object({
    name: zod.string(),
    contact_name: zod.string(),
    contact_email: zod.string(),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
    }),
  );

export const resellerCreateResponse = zod
  .object({
    name: zod.string(),
    contact_name: zod.string(),
    contact_email: zod.string(),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Get a reseller
 */
export const resellerGetParams = zod.object({
  id: zod.string().uuid(),
});

export const resellerGetResponse = zod
  .object({
    name: zod.string(),
    contact_name: zod.string(),
    contact_email: zod.string(),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Update a reseller
 */
export const resellerUpdateParams = zod.object({
  id: zod.string().uuid(),
});

export const resellerUpdateBody = zod.object({
  name: zod.string(),
  contact_name: zod.string(),
  contact_email: zod.string(),
});

export const resellerUpdateResponse = zod
  .object({
    name: zod.string(),
    contact_name: zod.string(),
    contact_email: zod.string(),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Delete a reseller
 */
export const resellerDeleteParams = zod.object({
  id: zod.string().uuid(),
});

/**
 * List available offerings
 */
export const offeringsListQueryParams = zod.object({
  reseller_id: zod.string().uuid().optional(),
});

export const offeringsListResponseEmailTemplateFilenameRegExp = new RegExp(
  '^[a-zA-Z0-9_-]+\\.gohtml$',
);

export const offeringsListResponse = zod
  .object({
    name: zod.string(),
    price: zod.number().describe('For display purposes'),
    tag: zod
      .string()
      .describe(
        'Tag for bobcat offer to purchase as part of this offering.\nGenerally something like pds_XXXXXX\n',
      ),
    payment_method: zod.object({
      name: zod.string(),
      rules: zod.array(
        zod.union([
          zod
            .object({
              type: zod.enum(['time_of_day_between_in']),
              ranges: zod.array(
                zod.object({
                  start: zod.string(),
                  end: zod.string(),
                }),
              ),
            })
            .describe(
              'Requires the current time of day to be withing one of the specified\nranges.\n',
            ),
          zod
            .object({
              type: zod.enum(['day_of_week_in']),
              days_of_week: zod.array(
                zod.enum([
                  'monday',
                  'tuesday',
                  'wednesday',
                  'thursday',
                  'friday',
                  'saturday',
                  'sunday',
                ]),
              ),
            })
            .describe(
              'Requires the current day of week to be one of the specified ones\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain only zones from\nthe specified list.\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain at least one of the\nspecified zones\n',
            ),
          zod
            .object({
              type: zod.enum(['traveller_class_in']),
              classes: zod.array(
                zod
                  .string()
                  .describe(
                    'A traveller class tag name. Generally something like tc_a\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to be for one of the\nspecified traveller classes\n',
            ),
          zod
            .object({
              type: zod.enum(['product_count_max']),
              count: zod.number(),
            })
            .describe(
              'Limit the maximum number of products that may be included\nwithin a purchase\n',
            ),
          zod
            .object({
              type: zod.enum(['or']),
              rules: zod.array(zod.unknown()),
            })
            .describe(
              'OR-operator, to enable more complex logic.\nDefault behavior is to AND all sibling rules.\n',
            ),
        ]),
      ),
    }),
    description: zod.string().optional(),
    sort_order: zod
      .number()
      .optional()
      .describe(
        'Relative sorting index for display purposes.\nLower indices appear earlier in lists.\n',
      ),
    email_template_filename: zod
      .string()
      .regex(offeringsListResponseEmailTemplateFilenameRegExp)
      .optional()
      .describe(
        'Filename of the selfservice confirmation email template to use\nfor this offering. Resolved under smtp/templates/{locale}/{tenant}/{action}/.\nOnly meaningful for selfservice offerings. Must match\n[a-zA-Z0-9_-]+\\.gohtml (basename only, no path segments).\n',
      ),
  })
  .and(
    zod.object({
      amount_inc_vat: zod.number(),
      amount_ex_vat: zod.number(),
      vat_rate: zod.number(),
      vat_amount: zod.number(),
      duration: zod.string().describe('Golang Duration.parse format'),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      reseller_id: zod.string().uuid(),
      type: zod.enum(['agent', 'self-service']),
      auth_system: zod.enum(['allbinary', 'grandid']),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
      slug: zod.string().optional().describe('Lower-case, hyphenated name'),
      transactions_tracked_externally: zod
        .boolean()
        .describe(
          "When true, the AllTix portal is the system of record for this\noffering's transactions: reseller-api skips creating its own\npayment cart purchase on grant. Only valid for self-service\nofferings — the database rejects it on any other type.\n",
        ),
      spar_region_validation: zod
        .object({
          lan_kod: zod
            .array(zod.string())
            .optional()
            .describe('Allowed 2-digit Swedish län codes, e.g. 24.'),
          kommun_kod: zod
            .array(zod.string())
            .optional()
            .describe(
              'Allowed 4-digit Swedish kommun codes (län + kommun\nconcatenated), e.g. 2480 for Umeå.\n',
            ),
        })
        .optional()
        .describe(
          'Residency restriction for self-service offerings. When present,\na recipient must clear offeringValidateRecipient before being\ngranted the offering. Both fields are optional; a recipient is\neligible when their folkbokföring matches at least one of the\nlisted län codes AND at least one of the listed kommun codes.\n',
        ),
    }),
  );

/**
 * Create a new offering
 */
export const offeringCreateBodyEmailTemplateFilenameRegExp = new RegExp(
  '^[a-zA-Z0-9_-]+\\.gohtml$',
);

export const offeringCreateBody = zod
  .object({
    name: zod.string(),
    price: zod.number().describe('For display purposes'),
    tag: zod
      .string()
      .describe(
        'Tag for bobcat offer to purchase as part of this offering.\nGenerally something like pds_XXXXXX\n',
      ),
    payment_method: zod.object({
      name: zod.string(),
      rules: zod.array(
        zod.union([
          zod
            .object({
              type: zod.enum(['time_of_day_between_in']),
              ranges: zod.array(
                zod.object({
                  start: zod.string(),
                  end: zod.string(),
                }),
              ),
            })
            .describe(
              'Requires the current time of day to be withing one of the specified\nranges.\n',
            ),
          zod
            .object({
              type: zod.enum(['day_of_week_in']),
              days_of_week: zod.array(
                zod.enum([
                  'monday',
                  'tuesday',
                  'wednesday',
                  'thursday',
                  'friday',
                  'saturday',
                  'sunday',
                ]),
              ),
            })
            .describe(
              'Requires the current day of week to be one of the specified ones\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain only zones from\nthe specified list.\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain at least one of the\nspecified zones\n',
            ),
          zod
            .object({
              type: zod.enum(['traveller_class_in']),
              classes: zod.array(
                zod
                  .string()
                  .describe(
                    'A traveller class tag name. Generally something like tc_a\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to be for one of the\nspecified traveller classes\n',
            ),
          zod
            .object({
              type: zod.enum(['product_count_max']),
              count: zod.number(),
            })
            .describe(
              'Limit the maximum number of products that may be included\nwithin a purchase\n',
            ),
          zod
            .object({
              type: zod.enum(['or']),
              rules: zod.array(zod.unknown()),
            })
            .describe(
              'OR-operator, to enable more complex logic.\nDefault behavior is to AND all sibling rules.\n',
            ),
        ]),
      ),
    }),
    description: zod.string().optional(),
    sort_order: zod
      .number()
      .optional()
      .describe(
        'Relative sorting index for display purposes.\nLower indices appear earlier in lists.\n',
      ),
    email_template_filename: zod
      .string()
      .regex(offeringCreateBodyEmailTemplateFilenameRegExp)
      .optional()
      .describe(
        'Filename of the selfservice confirmation email template to use\nfor this offering. Resolved under smtp/templates/{locale}/{tenant}/{action}/.\nOnly meaningful for selfservice offerings. Must match\n[a-zA-Z0-9_-]+\\.gohtml (basename only, no path segments).\n',
      ),
  })
  .and(
    zod.object({
      amount_inc_vat: zod.number(),
      amount_ex_vat: zod.number(),
      vat_rate: zod.number(),
      vat_amount: zod.number(),
      duration: zod.string().describe('Golang Duration.parse format'),
    }),
  );

export const offeringCreateResponseEmailTemplateFilenameRegExp = new RegExp(
  '^[a-zA-Z0-9_-]+\\.gohtml$',
);

export const offeringCreateResponse = zod
  .object({
    name: zod.string(),
    price: zod.number().describe('For display purposes'),
    tag: zod
      .string()
      .describe(
        'Tag for bobcat offer to purchase as part of this offering.\nGenerally something like pds_XXXXXX\n',
      ),
    payment_method: zod.object({
      name: zod.string(),
      rules: zod.array(
        zod.union([
          zod
            .object({
              type: zod.enum(['time_of_day_between_in']),
              ranges: zod.array(
                zod.object({
                  start: zod.string(),
                  end: zod.string(),
                }),
              ),
            })
            .describe(
              'Requires the current time of day to be withing one of the specified\nranges.\n',
            ),
          zod
            .object({
              type: zod.enum(['day_of_week_in']),
              days_of_week: zod.array(
                zod.enum([
                  'monday',
                  'tuesday',
                  'wednesday',
                  'thursday',
                  'friday',
                  'saturday',
                  'sunday',
                ]),
              ),
            })
            .describe(
              'Requires the current day of week to be one of the specified ones\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain only zones from\nthe specified list.\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain at least one of the\nspecified zones\n',
            ),
          zod
            .object({
              type: zod.enum(['traveller_class_in']),
              classes: zod.array(
                zod
                  .string()
                  .describe(
                    'A traveller class tag name. Generally something like tc_a\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to be for one of the\nspecified traveller classes\n',
            ),
          zod
            .object({
              type: zod.enum(['product_count_max']),
              count: zod.number(),
            })
            .describe(
              'Limit the maximum number of products that may be included\nwithin a purchase\n',
            ),
          zod
            .object({
              type: zod.enum(['or']),
              rules: zod.array(zod.unknown()),
            })
            .describe(
              'OR-operator, to enable more complex logic.\nDefault behavior is to AND all sibling rules.\n',
            ),
        ]),
      ),
    }),
    description: zod.string().optional(),
    sort_order: zod
      .number()
      .optional()
      .describe(
        'Relative sorting index for display purposes.\nLower indices appear earlier in lists.\n',
      ),
    email_template_filename: zod
      .string()
      .regex(offeringCreateResponseEmailTemplateFilenameRegExp)
      .optional()
      .describe(
        'Filename of the selfservice confirmation email template to use\nfor this offering. Resolved under smtp/templates/{locale}/{tenant}/{action}/.\nOnly meaningful for selfservice offerings. Must match\n[a-zA-Z0-9_-]+\\.gohtml (basename only, no path segments).\n',
      ),
  })
  .and(
    zod.object({
      amount_inc_vat: zod.number(),
      amount_ex_vat: zod.number(),
      vat_rate: zod.number(),
      vat_amount: zod.number(),
      duration: zod.string().describe('Golang Duration.parse format'),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      reseller_id: zod.string().uuid(),
      type: zod.enum(['agent', 'self-service']),
      auth_system: zod.enum(['allbinary', 'grandid']),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
      slug: zod.string().optional().describe('Lower-case, hyphenated name'),
      transactions_tracked_externally: zod
        .boolean()
        .describe(
          "When true, the AllTix portal is the system of record for this\noffering's transactions: reseller-api skips creating its own\npayment cart purchase on grant. Only valid for self-service\nofferings — the database rejects it on any other type.\n",
        ),
      spar_region_validation: zod
        .object({
          lan_kod: zod
            .array(zod.string())
            .optional()
            .describe('Allowed 2-digit Swedish län codes, e.g. 24.'),
          kommun_kod: zod
            .array(zod.string())
            .optional()
            .describe(
              'Allowed 4-digit Swedish kommun codes (län + kommun\nconcatenated), e.g. 2480 for Umeå.\n',
            ),
        })
        .optional()
        .describe(
          'Residency restriction for self-service offerings. When present,\na recipient must clear offeringValidateRecipient before being\ngranted the offering. Both fields are optional; a recipient is\neligible when their folkbokföring matches at least one of the\nlisted län codes AND at least one of the listed kommun codes.\n',
        ),
    }),
  );

/**
 * Get an offering
 */
export const offeringGetParams = zod.object({
  id: zod.string().uuid(),
});

export const offeringGetResponseEmailTemplateFilenameRegExp = new RegExp(
  '^[a-zA-Z0-9_-]+\\.gohtml$',
);

export const offeringGetResponse = zod
  .object({
    name: zod.string(),
    price: zod.number().describe('For display purposes'),
    tag: zod
      .string()
      .describe(
        'Tag for bobcat offer to purchase as part of this offering.\nGenerally something like pds_XXXXXX\n',
      ),
    payment_method: zod.object({
      name: zod.string(),
      rules: zod.array(
        zod.union([
          zod
            .object({
              type: zod.enum(['time_of_day_between_in']),
              ranges: zod.array(
                zod.object({
                  start: zod.string(),
                  end: zod.string(),
                }),
              ),
            })
            .describe(
              'Requires the current time of day to be withing one of the specified\nranges.\n',
            ),
          zod
            .object({
              type: zod.enum(['day_of_week_in']),
              days_of_week: zod.array(
                zod.enum([
                  'monday',
                  'tuesday',
                  'wednesday',
                  'thursday',
                  'friday',
                  'saturday',
                  'sunday',
                ]),
              ),
            })
            .describe(
              'Requires the current day of week to be one of the specified ones\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain only zones from\nthe specified list.\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain at least one of the\nspecified zones\n',
            ),
          zod
            .object({
              type: zod.enum(['traveller_class_in']),
              classes: zod.array(
                zod
                  .string()
                  .describe(
                    'A traveller class tag name. Generally something like tc_a\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to be for one of the\nspecified traveller classes\n',
            ),
          zod
            .object({
              type: zod.enum(['product_count_max']),
              count: zod.number(),
            })
            .describe(
              'Limit the maximum number of products that may be included\nwithin a purchase\n',
            ),
          zod
            .object({
              type: zod.enum(['or']),
              rules: zod.array(zod.unknown()),
            })
            .describe(
              'OR-operator, to enable more complex logic.\nDefault behavior is to AND all sibling rules.\n',
            ),
        ]),
      ),
    }),
    description: zod.string().optional(),
    sort_order: zod
      .number()
      .optional()
      .describe(
        'Relative sorting index for display purposes.\nLower indices appear earlier in lists.\n',
      ),
    email_template_filename: zod
      .string()
      .regex(offeringGetResponseEmailTemplateFilenameRegExp)
      .optional()
      .describe(
        'Filename of the selfservice confirmation email template to use\nfor this offering. Resolved under smtp/templates/{locale}/{tenant}/{action}/.\nOnly meaningful for selfservice offerings. Must match\n[a-zA-Z0-9_-]+\\.gohtml (basename only, no path segments).\n',
      ),
  })
  .and(
    zod.object({
      amount_inc_vat: zod.number(),
      amount_ex_vat: zod.number(),
      vat_rate: zod.number(),
      vat_amount: zod.number(),
      duration: zod.string().describe('Golang Duration.parse format'),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      reseller_id: zod.string().uuid(),
      type: zod.enum(['agent', 'self-service']),
      auth_system: zod.enum(['allbinary', 'grandid']),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
      slug: zod.string().optional().describe('Lower-case, hyphenated name'),
      transactions_tracked_externally: zod
        .boolean()
        .describe(
          "When true, the AllTix portal is the system of record for this\noffering's transactions: reseller-api skips creating its own\npayment cart purchase on grant. Only valid for self-service\nofferings — the database rejects it on any other type.\n",
        ),
      spar_region_validation: zod
        .object({
          lan_kod: zod
            .array(zod.string())
            .optional()
            .describe('Allowed 2-digit Swedish län codes, e.g. 24.'),
          kommun_kod: zod
            .array(zod.string())
            .optional()
            .describe(
              'Allowed 4-digit Swedish kommun codes (län + kommun\nconcatenated), e.g. 2480 for Umeå.\n',
            ),
        })
        .optional()
        .describe(
          'Residency restriction for self-service offerings. When present,\na recipient must clear offeringValidateRecipient before being\ngranted the offering. Both fields are optional; a recipient is\neligible when their folkbokföring matches at least one of the\nlisted län codes AND at least one of the listed kommun codes.\n',
        ),
    }),
  )
  .and(
    zod.object({
      offers: zod.array(
        zod.object({
          id: zod.string(),
          traveller_class: zod.string(),
        }),
      ),
    }),
  );

/**
 * Update an offering
 */
export const offeringUpdateParams = zod.object({
  id: zod.string().uuid(),
});

export const offeringUpdateBodyEmailTemplateFilenameRegExp = new RegExp(
  '^[a-zA-Z0-9_-]+\\.gohtml$',
);

export const offeringUpdateBody = zod.object({
  name: zod.string(),
  price: zod.number().describe('For display purposes'),
  tag: zod
    .string()
    .describe(
      'Tag for bobcat offer to purchase as part of this offering.\nGenerally something like pds_XXXXXX\n',
    ),
  payment_method: zod.object({
    name: zod.string(),
    rules: zod.array(
      zod.union([
        zod
          .object({
            type: zod.enum(['time_of_day_between_in']),
            ranges: zod.array(
              zod.object({
                start: zod.string(),
                end: zod.string(),
              }),
            ),
          })
          .describe(
            'Requires the current time of day to be withing one of the specified\nranges.\n',
          ),
        zod
          .object({
            type: zod.enum(['day_of_week_in']),
            days_of_week: zod.array(
              zod.enum([
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
                'sunday',
              ]),
            ),
          })
          .describe(
            'Requires the current day of week to be one of the specified ones\n',
          ),
        zod
          .object({
            type: zod.enum(['zones_in']),
            pid: zod
              .string()
              .describe(
                'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
              ),
            zones: zod.array(
              zod
                .string()
                .describe(
                  'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                ),
            ),
          })
          .describe(
            'Requires the purchased products to contain only zones from\nthe specified list.\n',
          ),
        zod
          .object({
            type: zod.enum(['zones_in']),
            pid: zod
              .string()
              .describe(
                'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
              ),
            zones: zod.array(
              zod
                .string()
                .describe(
                  'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                ),
            ),
          })
          .describe(
            'Requires the purchased products to contain at least one of the\nspecified zones\n',
          ),
        zod
          .object({
            type: zod.enum(['traveller_class_in']),
            classes: zod.array(
              zod
                .string()
                .describe(
                  'A traveller class tag name. Generally something like tc_a\n',
                ),
            ),
          })
          .describe(
            'Requires the purchased products to be for one of the\nspecified traveller classes\n',
          ),
        zod
          .object({
            type: zod.enum(['product_count_max']),
            count: zod.number(),
          })
          .describe(
            'Limit the maximum number of products that may be included\nwithin a purchase\n',
          ),
        zod
          .object({
            type: zod.enum(['or']),
            rules: zod.array(zod.unknown()),
          })
          .describe(
            'OR-operator, to enable more complex logic.\nDefault behavior is to AND all sibling rules.\n',
          ),
      ]),
    ),
  }),
  description: zod.string().optional(),
  sort_order: zod
    .number()
    .optional()
    .describe(
      'Relative sorting index for display purposes.\nLower indices appear earlier in lists.\n',
    ),
  email_template_filename: zod
    .string()
    .regex(offeringUpdateBodyEmailTemplateFilenameRegExp)
    .optional()
    .describe(
      'Filename of the selfservice confirmation email template to use\nfor this offering. Resolved under smtp/templates/{locale}/{tenant}/{action}/.\nOnly meaningful for selfservice offerings. Must match\n[a-zA-Z0-9_-]+\\.gohtml (basename only, no path segments).\n',
    ),
});

export const offeringUpdateResponseEmailTemplateFilenameRegExp = new RegExp(
  '^[a-zA-Z0-9_-]+\\.gohtml$',
);

export const offeringUpdateResponse = zod
  .object({
    name: zod.string(),
    price: zod.number().describe('For display purposes'),
    tag: zod
      .string()
      .describe(
        'Tag for bobcat offer to purchase as part of this offering.\nGenerally something like pds_XXXXXX\n',
      ),
    payment_method: zod.object({
      name: zod.string(),
      rules: zod.array(
        zod.union([
          zod
            .object({
              type: zod.enum(['time_of_day_between_in']),
              ranges: zod.array(
                zod.object({
                  start: zod.string(),
                  end: zod.string(),
                }),
              ),
            })
            .describe(
              'Requires the current time of day to be withing one of the specified\nranges.\n',
            ),
          zod
            .object({
              type: zod.enum(['day_of_week_in']),
              days_of_week: zod.array(
                zod.enum([
                  'monday',
                  'tuesday',
                  'wednesday',
                  'thursday',
                  'friday',
                  'saturday',
                  'sunday',
                ]),
              ),
            })
            .describe(
              'Requires the current day of week to be one of the specified ones\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain only zones from\nthe specified list.\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain at least one of the\nspecified zones\n',
            ),
          zod
            .object({
              type: zod.enum(['traveller_class_in']),
              classes: zod.array(
                zod
                  .string()
                  .describe(
                    'A traveller class tag name. Generally something like tc_a\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to be for one of the\nspecified traveller classes\n',
            ),
          zod
            .object({
              type: zod.enum(['product_count_max']),
              count: zod.number(),
            })
            .describe(
              'Limit the maximum number of products that may be included\nwithin a purchase\n',
            ),
          zod
            .object({
              type: zod.enum(['or']),
              rules: zod.array(zod.unknown()),
            })
            .describe(
              'OR-operator, to enable more complex logic.\nDefault behavior is to AND all sibling rules.\n',
            ),
        ]),
      ),
    }),
    description: zod.string().optional(),
    sort_order: zod
      .number()
      .optional()
      .describe(
        'Relative sorting index for display purposes.\nLower indices appear earlier in lists.\n',
      ),
    email_template_filename: zod
      .string()
      .regex(offeringUpdateResponseEmailTemplateFilenameRegExp)
      .optional()
      .describe(
        'Filename of the selfservice confirmation email template to use\nfor this offering. Resolved under smtp/templates/{locale}/{tenant}/{action}/.\nOnly meaningful for selfservice offerings. Must match\n[a-zA-Z0-9_-]+\\.gohtml (basename only, no path segments).\n',
      ),
  })
  .and(
    zod.object({
      amount_inc_vat: zod.number(),
      amount_ex_vat: zod.number(),
      vat_rate: zod.number(),
      vat_amount: zod.number(),
      duration: zod.string().describe('Golang Duration.parse format'),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      reseller_id: zod.string().uuid(),
      type: zod.enum(['agent', 'self-service']),
      auth_system: zod.enum(['allbinary', 'grandid']),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
      slug: zod.string().optional().describe('Lower-case, hyphenated name'),
      transactions_tracked_externally: zod
        .boolean()
        .describe(
          "When true, the AllTix portal is the system of record for this\noffering's transactions: reseller-api skips creating its own\npayment cart purchase on grant. Only valid for self-service\nofferings — the database rejects it on any other type.\n",
        ),
      spar_region_validation: zod
        .object({
          lan_kod: zod
            .array(zod.string())
            .optional()
            .describe('Allowed 2-digit Swedish län codes, e.g. 24.'),
          kommun_kod: zod
            .array(zod.string())
            .optional()
            .describe(
              'Allowed 4-digit Swedish kommun codes (län + kommun\nconcatenated), e.g. 2480 for Umeå.\n',
            ),
        })
        .optional()
        .describe(
          'Residency restriction for self-service offerings. When present,\na recipient must clear offeringValidateRecipient before being\ngranted the offering. Both fields are optional; a recipient is\neligible when their folkbokföring matches at least one of the\nlisted län codes AND at least one of the listed kommun codes.\n',
        ),
    }),
  );

/**
 * Delete an offering
 */
export const offeringDeleteParams = zod.object({
  id: zod.string().uuid(),
});

/**
 * Grant an offer to a traveller
 */
export const offeringGrantParams = zod.object({
  id: zod.string().uuid(),
});

export const offeringGrantBody = zod.object({
  offer_id: zod
    .string()
    .optional()
    .describe('Bobcat Sales offer ID. Retrieved via offeringGet'),
  traveller_id: zod
    .string()
    .describe('Bobcat Sales traveller ID. Retrieved via travellersFind'),
  bearer_id: zod
    .string()
    .optional()
    .describe(
      'Bobcat Sales mtb bearer ID.\nRetrieved via bearersFind, if needed (only for smartcards, so far)\n',
    ),
  email: zod
    .string()
    .email()
    .optional()
    .describe(
      'Optional email address for sending a confirmation email\nafter a successful grant.\n',
    ),
  recipient_nin: zod
    .string()
    .optional()
    .describe(
      '12-digit Swedish personnummer of the recipient. Required only\nwhen the offering has `spar_region_validation` set. Must match\nthe NIN that was validated to obtain `spar_token`.\n',
    ),
  spar_token: zod
    .string()
    .optional()
    .describe(
      'Base64-encoded signed token returned by\nofferingValidateRecipient. Required only when the offering has\n`spar_region_validation` set. Bound to (offering_id,\nrecipient_nin) and expires 15 minutes after issuance.\n',
    ),
});

export const offeringGrantResponse = zod
  .object({
    id: zod.string().uuid(),
    organization_id: zod.string(),
    offering_id: zod.string().uuid(),
    reseller_id: zod.string().uuid(),
    traveller_id: zod.string().describe('Bobcat Sales traveller ID'),
    state: zod.enum(['pending', 'aborted', 'active', 'expired', 'revoked']),
    created_at: zod.string().datetime({}),
    inception: zod.string().datetime({}),
    expiry: zod.string().datetime({}),
    deleted_at: zod.string().datetime({}).optional(),
    agent_id: zod.string().uuid().optional(),
    payment_method: zod
      .object({
        id: zod.string().describe('Bobcat Sales payment method ID'),
        token: zod.string().describe('Bobcat Sales payment method token'),
        wallet_id: zod.string().describe('Bobcat Sales wallet ID'),
        traveller_class: zod
          .string()
          .describe('Bobcat Sales traveller class tag'),
      })
      .optional(),
    transaction_id: zod
      .string()
      .optional()
      .describe('Bobcat Sales transaction ID'),
    selfservice_userid: zod
      .string()
      .optional()
      .describe(
        'Unique identifier for a selfservice user that does not otherwise\nexist in our database.\n',
      ),
    alltix_order_id: zod
      .string()
      .optional()
      .describe(
        'Order ID returned by the AllTix portal when the purchase was\nforwarded. Set only for offerings tracked externally; absent when\nforwarding was skipped or failed.\n',
      ),
    alltix_transaction_id: zod
      .string()
      .optional()
      .describe(
        'Transaction ID returned by the AllTix portal when the purchase\nwas forwarded. Set only for offerings tracked externally.\n',
      ),
    alltix_issued_ticket_id: zod
      .string()
      .optional()
      .describe(
        'Issued ticket ID returned by the AllTix portal when the purchase\nwas forwarded. Set only for offerings tracked externally.\n',
      ),
  })
  .and(
    zod.object({
      purchase_id: zod
        .string()
        .optional()
        .describe(
          'Present only when the granted offering is a selfservice\noffering. Currently a randomly generated reference string\nof the form `{TENANT}-{YYYYMMDD}-{6 hex chars}`. It is NOT\npersisted anywhere in this service. If an `email` was\nsupplied on the request and delivery succeeded, the same\nvalue also appears in that confirmation email. Treat it as\nan opaque display value.\n',
        ),
      ticket_id: zod
        .string()
        .optional()
        .describe(
          'Bobcat MTB product ID for the ticket created by this grant.\nPresent when the grant resulted in a purchased product. Use\nthis for support references back to Bobcat. Not persisted\nin this service — only returned on the grant response and\n(for selfservice grants with email) included in the\nconfirmation email.\n',
        ),
    }),
  );

/**
 * Check whether a recipient's Swedish personnummer satisfies the
offering's SPAR residency requirements. On success, returns a
short-lived signed token that must be passed back as `spar_token`
on the subsequent offeringGrant request, avoiding a second SPAR
lookup at grant time. The token is valid for 15 minutes and is
bound to the (offering_id, recipient_nin) pair.

If the offering has no SPAR region restriction, returns
`{ eligible: true }` with no token — the grant call does not
require `spar_token` in that case.

 */
export const offeringValidateRecipientParams = zod.object({
  id: zod.string().uuid(),
});

export const offeringValidateRecipientBody = zod.object({
  recipient_nin: zod
    .string()
    .describe('12-digit Swedish personnummer of the recipient.'),
});

export const offeringValidateRecipientResponse = zod.object({
  eligible: zod
    .boolean()
    .describe(
      'Always `true` on a 200 response. Ineligible recipients are\nreported as 403.\n',
    ),
  reason: zod
    .string()
    .optional()
    .describe('Human-readable reason when `eligible` is false.'),
  token: zod
    .string()
    .optional()
    .describe(
      'Base64-encoded signed proof to be sent as `spar_token` on the\nsubsequent offeringGrant request. Absent when the offering\nhas no `spar_region_validation` configured (in that case the\ngrant does not require a token).\n',
    ),
});

/**
 * Send a selfservice confirmation email without issuing a ticket.
Used when the user has no bearer and needs to pick up a physical
card from customer service.

 */
export const offeringNotifyParams = zod.object({
  id: zod.string().uuid(),
});

export const offeringNotifyBody = zod.object({
  email: zod
    .string()
    .email()
    .describe('Email address to send the notification to'),
});

export const offeringNotifyResponse = zod.object({
  purchase_id: zod
    .string()
    .describe(
      'Currently a randomly generated reference string of the form\n`{TENANT}-{YYYYMMDD}-{6 hex chars}`. It is NOT persisted anywhere\nin this service — the only other place it appears is in the\nconfirmation email that was sent as part of this request (if\nemail delivery succeeded). Treat it as an opaque display value.\n',
    ),
});

/**
 * Get an offering by slug
 */
export const offeringGetBySlugParams = zod.object({
  slug: zod.string(),
});

export const offeringGetBySlugResponseEmailTemplateFilenameRegExp = new RegExp(
  '^[a-zA-Z0-9_-]+\\.gohtml$',
);

export const offeringGetBySlugResponse = zod
  .object({
    name: zod.string(),
    price: zod.number().describe('For display purposes'),
    tag: zod
      .string()
      .describe(
        'Tag for bobcat offer to purchase as part of this offering.\nGenerally something like pds_XXXXXX\n',
      ),
    payment_method: zod.object({
      name: zod.string(),
      rules: zod.array(
        zod.union([
          zod
            .object({
              type: zod.enum(['time_of_day_between_in']),
              ranges: zod.array(
                zod.object({
                  start: zod.string(),
                  end: zod.string(),
                }),
              ),
            })
            .describe(
              'Requires the current time of day to be withing one of the specified\nranges.\n',
            ),
          zod
            .object({
              type: zod.enum(['day_of_week_in']),
              days_of_week: zod.array(
                zod.enum([
                  'monday',
                  'tuesday',
                  'wednesday',
                  'thursday',
                  'friday',
                  'saturday',
                  'sunday',
                ]),
              ),
            })
            .describe(
              'Requires the current day of week to be one of the specified ones\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain only zones from\nthe specified list.\n',
            ),
          zod
            .object({
              type: zod.enum(['zones_in']),
              pid: zod
                .string()
                .describe(
                  'ParticipantID. A unique identifier assigned to a transit\nauthority by BoB/Bobcat Sales\n',
                ),
              zones: zod.array(
                zod
                  .string()
                  .describe(
                    'Either a single zone or a range, defined by two zone identifiers\njoined by a hyphen.\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to contain at least one of the\nspecified zones\n',
            ),
          zod
            .object({
              type: zod.enum(['traveller_class_in']),
              classes: zod.array(
                zod
                  .string()
                  .describe(
                    'A traveller class tag name. Generally something like tc_a\n',
                  ),
              ),
            })
            .describe(
              'Requires the purchased products to be for one of the\nspecified traveller classes\n',
            ),
          zod
            .object({
              type: zod.enum(['product_count_max']),
              count: zod.number(),
            })
            .describe(
              'Limit the maximum number of products that may be included\nwithin a purchase\n',
            ),
          zod
            .object({
              type: zod.enum(['or']),
              rules: zod.array(zod.unknown()),
            })
            .describe(
              'OR-operator, to enable more complex logic.\nDefault behavior is to AND all sibling rules.\n',
            ),
        ]),
      ),
    }),
    description: zod.string().optional(),
    sort_order: zod
      .number()
      .optional()
      .describe(
        'Relative sorting index for display purposes.\nLower indices appear earlier in lists.\n',
      ),
    email_template_filename: zod
      .string()
      .regex(offeringGetBySlugResponseEmailTemplateFilenameRegExp)
      .optional()
      .describe(
        'Filename of the selfservice confirmation email template to use\nfor this offering. Resolved under smtp/templates/{locale}/{tenant}/{action}/.\nOnly meaningful for selfservice offerings. Must match\n[a-zA-Z0-9_-]+\\.gohtml (basename only, no path segments).\n',
      ),
  })
  .and(
    zod.object({
      amount_inc_vat: zod.number(),
      amount_ex_vat: zod.number(),
      vat_rate: zod.number(),
      vat_amount: zod.number(),
      duration: zod.string().describe('Golang Duration.parse format'),
    }),
  )
  .and(
    zod.object({
      id: zod.string().uuid(),
      organization_id: zod.string(),
      reseller_id: zod.string().uuid(),
      type: zod.enum(['agent', 'self-service']),
      auth_system: zod.enum(['allbinary', 'grandid']),
      created_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
      slug: zod.string().optional().describe('Lower-case, hyphenated name'),
      transactions_tracked_externally: zod
        .boolean()
        .describe(
          "When true, the AllTix portal is the system of record for this\noffering's transactions: reseller-api skips creating its own\npayment cart purchase on grant. Only valid for self-service\nofferings — the database rejects it on any other type.\n",
        ),
      spar_region_validation: zod
        .object({
          lan_kod: zod
            .array(zod.string())
            .optional()
            .describe('Allowed 2-digit Swedish län codes, e.g. 24.'),
          kommun_kod: zod
            .array(zod.string())
            .optional()
            .describe(
              'Allowed 4-digit Swedish kommun codes (län + kommun\nconcatenated), e.g. 2480 for Umeå.\n',
            ),
        })
        .optional()
        .describe(
          'Residency restriction for self-service offerings. When present,\na recipient must clear offeringValidateRecipient before being\ngranted the offering. Both fields are optional; a recipient is\neligible when their folkbokföring matches at least one of the\nlisted län codes AND at least one of the listed kommun codes.\n',
        ),
    }),
  )
  .and(
    zod.object({
      offers: zod.array(
        zod.object({
          id: zod.string(),
          traveller_class: zod.string(),
        }),
      ),
    }),
  );

/**
 * List granted offerings
 */
export const grantedOfferingsListQueryParams = zod.object({
  traveller_id: zod.string().optional().describe('Bobcat Sales traveller ID'),
  ids: zod
    .array(zod.string().uuid())
    .optional()
    .describe('List of granted offering UUIDs'),
});

export const grantedOfferingsListResponse = zod.object({
  id: zod.string().uuid(),
  organization_id: zod.string(),
  offering_id: zod.string().uuid(),
  reseller_id: zod.string().uuid(),
  traveller_id: zod.string().describe('Bobcat Sales traveller ID'),
  state: zod.enum(['pending', 'aborted', 'active', 'expired', 'revoked']),
  created_at: zod.string().datetime({}),
  inception: zod.string().datetime({}),
  expiry: zod.string().datetime({}),
  deleted_at: zod.string().datetime({}).optional(),
  agent_id: zod.string().uuid().optional(),
  payment_method: zod
    .object({
      id: zod.string().describe('Bobcat Sales payment method ID'),
      token: zod.string().describe('Bobcat Sales payment method token'),
      wallet_id: zod.string().describe('Bobcat Sales wallet ID'),
      traveller_class: zod
        .string()
        .describe('Bobcat Sales traveller class tag'),
    })
    .optional(),
  transaction_id: zod
    .string()
    .optional()
    .describe('Bobcat Sales transaction ID'),
  selfservice_userid: zod
    .string()
    .optional()
    .describe(
      'Unique identifier for a selfservice user that does not otherwise\nexist in our database.\n',
    ),
  alltix_order_id: zod
    .string()
    .optional()
    .describe(
      'Order ID returned by the AllTix portal when the purchase was\nforwarded. Set only for offerings tracked externally; absent when\nforwarding was skipped or failed.\n',
    ),
  alltix_transaction_id: zod
    .string()
    .optional()
    .describe(
      'Transaction ID returned by the AllTix portal when the purchase\nwas forwarded. Set only for offerings tracked externally.\n',
    ),
  alltix_issued_ticket_id: zod
    .string()
    .optional()
    .describe(
      'Issued ticket ID returned by the AllTix portal when the purchase\nwas forwarded. Set only for offerings tracked externally.\n',
    ),
});

/**
 * Revokes a granted offering
 */
export const grantedOfferingDeleteParams = zod.object({
  id: zod.string().uuid(),
});

export const grantedOfferingDeleteResponse = zod.object({
  id: zod.string().uuid(),
  organization_id: zod.string(),
  offering_id: zod.string().uuid(),
  reseller_id: zod.string().uuid(),
  traveller_id: zod.string().describe('Bobcat Sales traveller ID'),
  state: zod.enum(['pending', 'aborted', 'active', 'expired', 'revoked']),
  created_at: zod.string().datetime({}),
  inception: zod.string().datetime({}),
  expiry: zod.string().datetime({}),
  deleted_at: zod.string().datetime({}).optional(),
  agent_id: zod.string().uuid().optional(),
  payment_method: zod
    .object({
      id: zod.string().describe('Bobcat Sales payment method ID'),
      token: zod.string().describe('Bobcat Sales payment method token'),
      wallet_id: zod.string().describe('Bobcat Sales wallet ID'),
      traveller_class: zod
        .string()
        .describe('Bobcat Sales traveller class tag'),
    })
    .optional(),
  transaction_id: zod
    .string()
    .optional()
    .describe('Bobcat Sales transaction ID'),
  selfservice_userid: zod
    .string()
    .optional()
    .describe(
      'Unique identifier for a selfservice user that does not otherwise\nexist in our database.\n',
    ),
  alltix_order_id: zod
    .string()
    .optional()
    .describe(
      'Order ID returned by the AllTix portal when the purchase was\nforwarded. Set only for offerings tracked externally; absent when\nforwarding was skipped or failed.\n',
    ),
  alltix_transaction_id: zod
    .string()
    .optional()
    .describe(
      'Transaction ID returned by the AllTix portal when the purchase\nwas forwarded. Set only for offerings tracked externally.\n',
    ),
  alltix_issued_ticket_id: zod
    .string()
    .optional()
    .describe(
      'Issued ticket ID returned by the AllTix portal when the purchase\nwas forwarded. Set only for offerings tracked externally.\n',
    ),
});

/**
 * List travellers for email
 */
export const travellersFindQueryParams = zod.object({
  email: zod.string().email(),
});

export const travellersFindResponseItem = zod
  .object({
    id: zod.string(),
    email: zod.string().email(),
    name: zod.string(),
  })
  .describe('Bobcat Sales traveller');
export const travellersFindResponse = zod.array(travellersFindResponseItem);

/**
 * Get bearer for card serial
 */
export const bearersFindQueryParams = zod.object({
  card_serial: zod.string(),
});

export const bearersFindResponse = zod.object({
  id: zod.string(),
  traveller_id: zod.string().optional(),
});
